<div class="loader">
    <div id="overlay">
        <div class="spinner-grow text-custom" role="status">
            <span class="sr-only"></span>
        </div>
        <!-- <div class="loaders-wrapper">
            <div class="loader2"></div>
        </div> -->
    </div>
</div>